import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { loginUser } from '../services/api';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
   const params = new URLSearchParams(location.search);
   const isExpired = params.get('expired') === 'true';
   const isReset = params.get('reset') === 'true';
   const redirectPath = params.get('redirect');
   const [showPassword, setShowPassword] = useState(false);
 
   // Clear session if reset requested
   React.useEffect(() => {
     if (isReset) {
       localStorage.clear();
       // Remove reset param from URL to clean up
       window.history.replaceState({}, '', '/login');
     }
   }, [isReset]);
 
   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
     setFormData({
       ...formData,
       [e.target.name]: e.target.value,
     });
   };
 
   const handleSubmit = async (e: React.FormEvent) => {
     e.preventDefault();
     setError(null);
 
     const body = new URLSearchParams();
     body.append('username', formData.email);
     body.append('password', formData.password);
 
     try {
       await loginUser(body);
       navigate(redirectPath || '/dashboard');
     } catch (error: any) {
       setError(error.message);
     }
   };

  return (
    <div className="light-theme-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow-sm">
              <div className="card-body p-4">
                <h3 className="card-title text-center mb-4">Iniciar sesión</h3>
                <form onSubmit={handleSubmit}>
                  {isExpired && <div className="alert alert-warning">Su sesión ha expirado. Por favor, inicie sesión nuevamente.</div>}
                  {error && <div className="alert alert-danger">{error}</div>}
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Correo electrónico</label>
                    <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleChange} required />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Contraseña</label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`}></i>
                      </button>
                    </div>
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary">
                      Ingresar
                    </button>
                  </div>
                </form>
                <div className="text-center mt-3">
                  <p>
                    ¿No tienes una cuenta? <Link to="/register">Regístrate aquí</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
